import React, { ChangeEventHandler } from 'react';

import styled from 'styled-components';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import {
  FloatingLabelInput,
  FloatingLabelSelect,
  ISelectOption,
} from 'components/floating-label-fields';
import { ModalContent } from 'components/modal';

import { ActionContainer, ActionsContainer, StyledModalHeading } from './styled';

const SubHeading = styled.p`
  color: ${Styles.color.grey.three};
`;
const InputsContainer = styled.div`
  width: 75%;
`;

interface IProps {
  onDateChange: ChangeEventHandler<HTMLInputElement>;
  onTimeChange: ChangeEventHandler<HTMLSelectElement>;
  date: string;
  minDate: string;
  maxDate: string;
  time: string;
  timeOptions: ISelectOption[];
  validDateTime: boolean;
  onContinue(): void;
  onBack(): void;
  headingText: string;
  subheadingText: string;
  backButtonText: string;
  continueButtonText: string;
}

const PickupDetails = ({
  onDateChange,
  onTimeChange,
  date,
  minDate,
  maxDate,
  time,
  timeOptions,
  validDateTime,
  onBack,
  onContinue,
  headingText,
  subheadingText,
  backButtonText,
  continueButtonText,
}: IProps) => {
  return (
    <ModalContent>
      <StyledModalHeading id="modal-heading">{headingText}</StyledModalHeading>
      <SubHeading>{subheadingText}</SubHeading>
      <InputsContainer>
        <FloatingLabelInput
          label="Date"
          name="date"
          type="date"
          value={date}
          min={minDate}
          max={maxDate}
          onChange={onDateChange}
          required
          validation={undefined}
          message={undefined}
        />
        <FloatingLabelSelect
          label="Time"
          value={time}
          options={timeOptions}
          onChange={onTimeChange}
          required
          validation={undefined}
          message={undefined}
        />
      </InputsContainer>
      <ActionsContainer>
        <ActionContainer>
          <ActionButton
            variant={ActionButtonVariants.TEXT_ONLY}
            size={ActionButtonSizes.SMALL}
            onClick={onBack}
          >
            {backButtonText}
          </ActionButton>
        </ActionContainer>
        <ActionContainer>
          <ActionButton disabled={!validDateTime} onClick={onContinue}>
            {continueButtonText}
          </ActionButton>
        </ActionContainer>
      </ActionsContainer>
    </ModalContent>
  );
};

export default PickupDetails;
